import { render, staticRenderFns } from "./LatestShipments.vue?vue&type=template&id=ab657da6&scoped=true"
import script from "./LatestShipments.vue?vue&type=script&lang=js"
export * from "./LatestShipments.vue?vue&type=script&lang=js"
import style0 from "./LatestShipments.vue?vue&type=style&index=0&id=ab657da6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab657da6",
  null
  
)

export default component.exports